/* 短信验证码 */
<template>
  <div class="news-inspect-box">
    <!-- 头部 -->
    <headerTop
      title="设置支付密码"
      :isCustomeBack="true"
      @customeBackEvent="customeBack"
    ></headerTop>
    <!-- 内容 -->
    <div class="cocntent">
      <div class="title">
        设置支付密码前，请先进行手机验证
        <!-- {{
          isForget
            ? "设置支付密码前，请先进行手机验证"
            : "您未设置交易密码，设置前，请先完成手机号验证"
        }} -->
      </div>
      <div class="cocntent-item verification">
        <div class="cocntent-item-l">
          <span>手机号</span>
          <span>{{
            userInfo.phone
              ? userInfo.phone.substring(0, 3) +
                "****" +
                userInfo.phone.substring(7, 11)
              : userInfo.phone
          }}</span>
        </div>
        <div
          :class="
            content == '发送验证码'
              ? 'cocntent-item-r'
              : 'cocntent-item-r-active'
          "
        >
          <span @click="countDown">{{ content }}</span>
        </div>
      </div>
      <div class="cocntent-item code">
        <div class="cocntent-item-l">
          <span>验证码</span>
          <input
            v-model="sendCode"
            type="text"
            placeholder="请输入验证码"
            maxlength="6"
            onkeyup="value=value.replace(/[^\w\.\/]/ig,'')"
          />
        </div>
      </div>
    </div>
    <div class="foot-btn">
      <div class="btn" @click="toPaymentPassword">提交</div>
    </div>
  </div>
</template>

<script>
import headerTop from "@/components/common/headerTop.vue";
import commonApi from "@/api/commonApi";

export default {
  data() {
    return {
      isForget:
        this.$route.query.forget || parseInt(this.$route.query.forget, 10) === 1
          ? true
          : false,
      content: "发送验证码", // 按钮里显示的内容
      totalTime: 60, //记录具体倒计时时间
      canClick: true, //添加canClick
      userInfo: {}, // 用户基本信息
      sendCode: "",
    };
  },
  methods: {
    customeBack() {
      this.$router.push({
        name: "myUserHome"
      });
    },
    // 倒计时
    countDown() {
      if (!this.canClick) return;
      this.canClick = false;

      // 发送短信验证码
      let data = {
        phone: this.userInfo.phone,
        sms_type: 2,
        user_id: this.userInfo.user_id,
      };
      commonApi.sendSmscode(data).then((res) => {
        console.log(res);
      });

      this.content = this.totalTime + "s后重新发送";
      let clock = window.setInterval(() => {
        this.totalTime--;
        this.content = this.totalTime + "s后重新发送";
        if (this.totalTime < 1) {
          //当倒计时小于1时清除定时器
          window.clearInterval(clock);
          this.content = "发送验证码";
          this.totalTime = 60;
          this.canClick = true; //这里重新开启
        }
      }, 1000);
    },
    // 跳转到设置支付密码
    toPaymentPassword() {
      if (this.sendCode.length < 6) {
        this.$toast({
          message: "请输入完整的验证码",
        });
        return false;
      }

      this.$router.push({
        name: "paymentPassword",
        params: {
          send_code: this.sendCode,
        },
      });
    },
  },
  components: {
    headerTop,
  },
  mounted() {
    this.userInfo = this.$store.state.userInfo;
  },
};
</script>

<style lang="less" scoped>
.news-inspect-box {
  .cocntent {
    padding: 30px;
    .title {
      font-size: 14px;
      color: #999999;
      margin-bottom: 15px;
    }
    .cocntent-item {
      height: 50px;
      width: 100%;
      border-bottom: 1px solid #cccccc;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      color: #333333;
      .cocntent-item-l {
        & span:nth-child(2) {
          margin-left: 32px;
        }
      }
      .cocntent-item-r {
        span {
          font-size: 14px;
          color: #8a3e2f;
        }
      }
      .cocntent-item-r-active {
        span {
          font-size: 14px;
          color: #cccccc;
        }
      }
    }
    .code {
      .cocntent-item-l {
        input {
          margin-left: 32px;
        }
      }
    }
  }
  .foot-btn {
    padding: 0 30px;
    .btn {
      width: 100%;
      height: 44px;
      background: #8a3e2f;
      text-align: center;
      line-height: 44px;
      font-size: 17px;
      color: #ffffff;
    }
  }
}
</style>
